// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"183":"8b02fcf8","327":"5ef1bdcf","420":"b76a42ed","662":"1dd3fcd0","666":"decc245b","720":"3ec54acc","743":"298a6611","808":"851fb3f8","940":"94c9f4c2"}[chunkId] + ".chunk.js";
};